import GeoJSON from 'geojson';

const geojsonUtilities = {
    /**
     * convert a point, linestring, polygon or an array of those types to geojson data
     * @param data: a specifically formatted object or array of objects. The format:
     * {
     *     point.lat: latitude (optional),
     *     point.long: longitude (optional),
     *     line: linestring,
     *     polygon: polygon,
     *     id: a string id of the point,
     *     *: all other properties will be included inside the geojson properties
     *
     * }
     */
    //@todo include another property: address, that will be used to reverse geocode the point if no other geo-properties have been set
    toGeoJSON(data){
        data = data || [];

        const splitted = geojsonUtilities.splitData(data);
        let geoData = GeoJSON.parse(splitted.points, {Point: ['point.lat','point.long']});
        let lineGeoData = GeoJSON.parse(splitted.lines, {LineString: 'line'});
        let multilineGeoData = GeoJSON.parse(splitted.multilines, {MultiLineString: 'multiline'});
        let polygonGeoData = GeoJSON.parse(splitted.polygons, {Polygon: 'polygon'});

        geoData.features = geoData.features.concat(lineGeoData.features);
        geoData.features = geoData.features.concat(multilineGeoData.features);
        geoData.features = geoData.features.concat(polygonGeoData.features);

        return geoData;
    },
    splitData(data){
        data = data || [];
        let result = {
            points:[],
            lines:[],
            multilines: [],
            polygons:[]
        };
        data.map(feature => {
           if(feature.hasOwnProperty('point')){
               result.points.push(feature);
           }
           else if(feature.hasOwnProperty('line')){
               result.lines.push(feature);
           }
           else if(feature.hasOwnProperty('multiline')){
               result.multilines.push(feature);
           }
           else if(feature.hasOwnProperty('polygon')){
               result.polygons.push(feature);
           }
        });
        return result;
    },
    translate(map, locale){
        let layerIds = [
            //"tunnel-oneway-arrow-blue",
            //"tunnel-oneway-arrow-white",
            //"road-oneway-arrow-blue",
            //"level-crossing",
            //"road-oneway-arrow-white",
            //"bridge-oneway-arrow-blue",
            //"bridge-oneway-arrow-white",
            "contour-label",
            //"building-number-label",
            "road-label",
            //"road-number-shield",
            //"road-exit-shield",
            //"golf-hole-label",
            "waterway-label",
            "natural-line-label",
            "natural-point-label",
            "water-line-label",
            "water-point-label",
            "poi-label",
            "transit-label",
            "airport-label",
            "settlement-subdivision-label",
            "settlement-label",
            "state-label",
            "country-label"
        ];
        if (!locale || !["de", "en"].includes(locale)) {
            locale = "de";
        }
        layerIds.forEach((layerId) => {
            try {
                //map.getLayoutProperty(layerId, `name_${locale}`);
                map.setLayoutProperty(layerId, 'text-field', ['get', `name_${locale}`]);
            }catch(ex){
                console.log(ex);
            }
        });
    },
    parseGeojsonString(geoJsonString){
        if(typeof geoJsonString !== "string")
            return [];
        if(geoJsonString.indexOf("MULTILINESTRING") !== -1){
            return geojsonUtilities.parseMultilinestring(geoJsonString);
        }
        else if(geoJsonString.indexOf("LINESTRING") !== -1){
            return geojsonUtilities.parseLinestring(geoJsonString);
        }
        return [];
    },
    parseLinestring(geojsonString){
        let matches = geojsonString.match("LINESTRING Z [\(](.+)[\)]");
        if(matches.length < 2)
            return [];
        return matches[1].split(",").map(group => {
            return group.trim().split(" ").slice(0, 2).map(c => parseFloat(c));
        });
    },
    parseMultilinestring(geojsonString){
        let matches = geojsonString.match("MULTILINESTRING Z [\(](.+)[\)]");
        if(matches.length < 2)
            return [];
        let lines = matches[1].split("),(").map(line => {
           if(line.charAt(0) == "(")
               line = line.substr(1);
           if(line.charAt(line.length - 1))
               line = line.substr(0, line.length - 1);
           return line;
        });

        return lines.map(group => {
            return group.trim().split(",").map(subgroup => {
                return subgroup.trim().split(" ").slice(0, 2).map(c => parseFloat(c));
            });
        });
    }
};
export default geojsonUtilities;